
import React from "react";
import { Link } from "react-router-dom";

interface ProductModule {
  name: string;
  icon: React.ElementType;
  href: string;
  comingSoon?: boolean;
}
interface ProductModulesGridProps {
  modules: ProductModule[];
  onClose: () => void;
  onNavigationClick?: (href: string) => void;
}

export const ProductModulesGrid: React.FC<ProductModulesGridProps> = ({ modules, onClose, onNavigationClick }) => {
  const handleLinkClick = (href: string, e: React.MouseEvent) => {
    if (onNavigationClick) {
      e.preventDefault();
      onNavigationClick(href);
    }
    onClose();
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-1.5">
      {modules.map((mod, idx) => (
        <Link
          to={mod.href}
          key={mod.href || idx}
          onClick={(e) => handleLinkClick(mod.href, e)}
          className="flex items-center gap-1.5 px-2 py-1.5 rounded-lg hover:bg-gray-50 group transition-colors"
        >
          <mod.icon className="h-3.5 w-3.5 text-muted-foreground group-hover:text-blue-600 transition-colors flex-shrink-0" />
          <span className="text-xs text-gray-500 group-hover:text-blue-600 font-medium flex items-center gap-1">
            {mod.name}
            {mod.comingSoon && (
              <span className="ml-1 rounded bg-yellow-100 text-yellow-800 text-[9px] font-semibold px-1.5 py-0.5">
                Coming Soon
              </span>
            )}
          </span>
        </Link>
      ))}
    </div>
  );
};
